module.exports = __webpack_public_path__ + "img/collection-weddingRingsWaveDesign@2x.e94d056.jpg";